import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { baseUrl } from 'src/app/shared/utils';
import { environment } from 'src/environments/environment';

type A = (typeof environment)['apps'][number];

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.css'],
})
export class VerifyComponent implements OnInit {
  constructor(private service: Auth0Service, activeRoute: ActivatedRoute) {
    activeRoute.params.subscribe(async (params) => {
      const clientId = params.client_id;
      const redirectUrl = this.getRedirectUrl({
        clientId: clientId,
        appConfig: environment.apps[clientId],
        url: location.href,
      });
      if (!redirectUrl) {
        // 異常系. 設定値を見つけられない場合はリダイレクトしない
        return;
      }
      try {
        const l = await service.checkLogin({
          redirectUri: baseUrl(clientId),
        });
        location.href = redirectUrl;
      } catch (error) {
        location.href = redirectUrl;
      }
    });
  }

  getRedirectUrl(params: {
    clientId: string;
    appConfig?: Pick<A, 'appUrl' | 'customUrls'>;
    url: string;
  }) {
    const app = params.appConfig;
    // リダイレクト先のURLを取得suru
    const redirectUrl =
      app?.customUrls?.onEmailVerificationFinish || // カスタム設定があればそれを使う
      app?.appUrl; // なければ共通のappUrlを使う

    return redirectUrl;
  }

  ngOnInit(): void {}
}
